<template>
  <div id="contenedor-listado-desktop">
    <v-data-table :headers="headers" :items="contratosEstatus" :items-per-page="20">
      <template v-slot:[`item.color`]="{ item }">
        <v-avatar
        size="35"
        :color="item.color">
        </v-avatar>
      </template>
      <template v-slot:[`item.createdAt`]="{ item }">
        <fecha-humano :fecha="new Date(item.createdAt)"></fecha-humano>
      </template>
      <template v-slot:[`item.acciones`]="{ item }">
      <v-tooltip
      v-if="mixValidaScopesActions(2)"
      top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on" @click="editar(item)">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>
        <span>Editar</span>
      </v-tooltip>
      <v-tooltip
      v-if="mixValidaScopesActions(3)"
      top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on" @click="eliminar(item)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
        <span>Borrar</span>
      </v-tooltip>
    </template>
    </v-data-table>
  </div>
</template>

<script>
import FechaHumano from '@/components/FechaHumano.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'ListadoContratosEstatusDesktop',
  components: {
    FechaHumano,
  },
  props: {
    contratosEstatus: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      headers: [
        { text: '', width: 60, value: 'color' },
        {
          text: 'Nombre',
          align: 'start',
          value: 'nombre',
        },
        { text: 'F. Registro', value: 'createdAt' },
        {
          text: '', value: 'acciones', align: 'end', sortable: false,
        },
      ],
    };
  },
  methods: {
    editar(statusContrato) {
      eventBus.$emit('editar-contrato-estatus', statusContrato);
    },
    eliminar(statusContrato) {
      eventBus.$emit('eliminar-contrato-estatus', statusContrato);
    },
  },
};
</script>

<style lang="scss">

</style>
